import { useMemo } from "react";
import content from "../data/content.json";
import { useCmsDoc } from "./useCmsDoc";

const HOME_FALLBACK = {
  hero: content.hero,
  stats: content.stats,
  knowledgeHub: content.knowledgeHub,
  servicesSection: content.servicesSection,
};

export function useSiteHome() {
  const fallback = useMemo(() => HOME_FALLBACK, []);
  return useCmsDoc("site", "home", fallback);
}
